import * as mutations from '../../mutation-types'
import * as Vue from "vue"

export const fetchProposalsLeadSources = (store, params = {}) => {
    return axios.get('/api/stats/proposals-lead-sources', {params}).then(res => {
        store.commit(mutations.SET_PROPOSALS_LEAD_SOURCES, res.data)
        return res.data
    })
}

export const fetchProposalStatusesSummary = (store, params = {}) => {
    return axios.get('/api/stats/proposal-statuses-summary', {params}).then(res => {
        store.commit(mutations.SET_PROPOSAL_STATUSES_SUMMARY, res.data)
        return res.data
    })
}
